/* eslint-disable */
/**
 * GTA／多倫多一帶「順風車／共乘分攤」嘅粗略參考（每位、單程、固定單價）。
 *
 * 「公平」校準（2026 左右、再檢視）：
 * - 全車油費粗估約 **$0.13–0.17／km**（視油耗同安省汽油價）。
 * - 若 2 位乘客同車主分攤，「淨油」每位往往接近 (全車油費÷乘客位數)；網上帖實際開價多數會**高過純油**（時間、佔位、風險），但應**明顯低過 Uber／Lyft**。
 * - 呢條式用**兩段路程**：前一段用較高 $／km（市區／短途），超出後用較低 $／km（近似高速、油耗較好），長途唔會線性飆得太快。
 *
 * 大約中位（方便對眼）：
 *   ~15 km → ~$6 | ~30 km → ~$10 | ~50 km → ~$14 | ~80 km → ~$20
 *
 * 仍係估算，唔係定價建議。
 *
 * @param {number} distanceKm 駕車路程（公里）
 * @returns {{ low: number, mid: number, high: number, distanceKm: number }|null}
 */
export function torontoCarpoolReferenceBand(distanceKm) {
  const km = Math.max(0, Number(distanceKm) || 0);
  if (!km || km <= 0) return null;

  const base = 2.0;
  const firstSegmentKm = 30;
  const perKmUrban = 0.28;
  const perKmExtra = 0.19;

  const urbanPart = Math.min(km, firstSegmentKm);
  const extraPart = Math.max(0, km - firstSegmentKm);
  let mid = base + urbanPart * perKmUrban + extraPart * perKmExtra;

  mid = Math.min(52, Math.max(3.2, mid));
  mid = Math.round(mid * 10) / 10;

  const spread = 0.1;
  const low = Math.round(mid * (1 - spread) * 10) / 10;
  const high = Math.round(mid * (1 + spread) * 10) / 10;

  return { low, mid, high, distanceKm: Math.round(km * 10) / 10 };
}
